import { connectHits } from 'instantsearch.js/es/connectors'
import hitPublication from './hitPublication'
import hitNewsEvent from './hitNewsEvent'
import hitPhoto from './hitPhoto'
import refreshAttribute from '../refreshAttribute'

const renderHits = (renderOptions, isFirstRender) => {
  const { hits, widgetParams } = renderOptions

  widgetParams.container.innerHTML = ''

  const results = widgetParams.searchInstance.renderState[`${config.algolia.env}_pages`].hits.results
  const currentPage = results !== undefined ? results.page : 0

  if (hits.length !== 0) {
    const ul = document.createElement('ul')
    ul.classList.add('row')

    hits.forEach((hit, i) => {
      // create li element, add classes
      const li = document.createElement('li')
      let size = 'M'

      if (widgetParams.type === 'photo') {
        li.className = 'col-12 md-col-6 lg-col-4 flex'
      } else {
        if (currentPage === 0 && i < 2) {
          li.className = 'col-12 md-col-6 flex'
          size = 'L'
        } else {
          li.className = 'col-12 md-col-6 xl-col-4 flex'
        }
      }

      if (widgetParams.type === 'news') {
        li.innerHTML = hitNewsEvent(hit, size)
      } else if (widgetParams.type === 'publication') {
        li.innerHTML = hitPublication(hit, size, widgetParams.userConnected ? widgetParams.userConnected : false)
      } else if (widgetParams.type === 'photo') {
        li.innerHTML = hitPhoto(hit)
      }

      ul.appendChild(li)
    })

    widgetParams.container.appendChild(ul)

    widgetParams.container.querySelectorAll('[js-dynamic-modal]').forEach(elem => {
      refreshAttribute('js-dynamic-modal')(elem)
    })
  } else {
    const empty = document.createElement('p')
    empty.classList.add('empty', 'text-white')
    empty.innerHTML = 'Aucun résultat'
    widgetParams.container.append(empty)
  }
}

const customHits = connectHits(renderHits)

export default customHits
